// extracted by mini-css-extract-plugin
export default {"wrapper":"createPromo_wrapper__fEX2y"};